import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewEncapsulation, ViewChild } from '@angular/core';
import {DemoService} from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import { Subscription } from 'rxjs';

import {CreateJob2Component} from './../../create-job-2/create-job-2.component';

import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { SubjectCommunication } from '../../../../shared/models/subjectCommunication.model';

// import { ToolbarService, DocumentEditorContainerComponent } from '@syncfusion/ej2-angular-documenteditor';
// import { isNullOrUndefined } from '@syncfusion/ej2-base';

// DocX - https://docx.js.org/#/?id=welcome
// import { Document, Packer, Paragraph, TextRun } from 'docx';

@Component({
  selector: 'app-subject-notes-tab',
  templateUrl: './subject-notes-tab.component.html',
  styleUrls: ['./subject-notes-tab.component.css']
})
export class SubjectNotesTabComponent implements OnInit {
  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  subject_id;
  subject_notes: Object;
  subjects: Object;

  public data: any;
  public initialPage: Object;
  formatoptions: { type: string; format: string; };
  job_id: any;
  file_number;
  model: any;

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
  ) {

   

    // login vars
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log('sessionUserId: ', this.currentUserVAR.user_id );
    console.log('sessionUsername: ', this.currentUserVAR.username );
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUserName = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;
   }

  ngOnInit() {

    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
    this.getJobSubject(this.subject_id);
    // this.getSubjectNotes(this.subject_id);

   // this.data = this.subject_notes;
    this.initialPage = { pageSizes: true, pageCount: 4 };
    this.formatoptions = { type: 'datetime', format: "M/d/y hh:mm" }
  }



  subjectView2(subject_id) {
      
    this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']));
  
  // works but does not refresh the page only if set up as a listner.
  // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
 }

 jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}


subjectCommunication(subject_id) {
  this.router.navigate(['/admin/jobs/subject/communication/' + subject_id + '']);
}

subjectDocuments(subject_id) {
  this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
}

subjectNotesTab(subject_id) {
  this.router.navigate(['/admin/jobs/subject/notes/' + subject_id + '']);
}





getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.subjects = data;
      const res = data[0];
     // this.getSubjectNotes(res.subject_id);

    
     this.job_id = res.job_id;
      this.file_number = res.file_number;
      this.getSubjectNotesProgressionTable(res.job_id, res.file_number, this.model );

      
     // load subject history
// this.getSubjectProgress(res.job_id, res.file_number);

/*
this.job_id = res.job_id;
this.subject_number = res.subject_number;
this.refreshList(); // loads the file list (diretory)
this.displaySubjectDocuments(this.subject_id, this.subject_number);


this.getJobTypeLocations(res.job_type_id);
this.getJobTypeCourts(res.job_type_location_id);
this.getJobTypeDocumentTypes(res.job_type_court_id);
this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
this.getJobTypes();
*/

// get job type in relation to subject
// this.getJobType(res.job_type_id);
// this.getJobTypeLocation(res.job_type_location_id);
// this.getJobTypeCourt(res.job_type_court_id);
// this.getJobTypeDocument(res.job_type_document_type_id);
// this.getJobTypeAffidavit(res.job_type_affidavit_type_id);



    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





getSubjectNotes(subject_id) {
  this._demoService.getSubjectNotes(subject_id).subscribe(
    data => { this.subject_notes = data;
     // console.log("Done loadng USER");
     // console.log(this.users);
    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }



  getSubjectNotesProgression(job_id, file_number) {
    this._demoService.getSubjectNotesProgression(job_id, file_number).subscribe(
      data => { this.subject_notes = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
 

      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    ); }

    getSubjectNotesProgressionTable(job_id, file_number, model) {
      this._demoService.getSubjectNotesProgressionTable(job_id, file_number, model).subscribe(
        data => { this.subject_notes = data;
         // console.log("Done loadng USER");
         // console.log(this.users);
   
  
        },
        error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
        }
      ); }



}
